import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function TRTHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-2209">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/nxsGz1UfdbWr8mtdZvxR77/testosterone-replacement-for-men.jpg)'
    }} data-id="element-2210" />
      <div className="absolute inset-0 bg-black/50" data-id="element-2211" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-2212">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-2213">
          <div className="mb-6" data-id="element-2214">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-2215">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-2216">
                Treatments
              </a>{' '}
              / Medical
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-2217">
            Be FOCUSED
          </span>

          <h1 className="text-[28px] sm:text-3xl lg:text-[44px] uppercase text-white tracking-tight mb-3 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-2218">
            TESTOSTERONE REPLACEMENT THERAPY FOR MEN
          </h1>

          <p className="text-white text-2xl italic mb-6 opacity-80 font-serif" data-id="element-2219">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-2220">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2221">
              Are you experiencing low energy, reduced sex drive or difficulty
              retaining muscle mass? TRT will change your life!
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2222">
              <em data-id="element-2223">"Did you know testosterone steadily declines at 30,"</em>{' '}
              explains Dr. Fiona.{' '}
              <em data-id="element-2224">
                "This decline can lead to multiple symptoms in the mind and
                body. Issues like decreased muscle mass and increased fat,
                erectile dysfunction and low libido, agitation and sleep issues
                are all signs of low T."
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2225">
              At Be CLINICAL, our Testosterone Replacement Therapy (TRT)
              treatments help you achieve an ideal hormonal balance with
              transformative results. We offer a variety of delivery methods,
              including TRT creams, testosterone pellets, injections, and
              sublingual troches, allowing for personalized treatment tailored
              to your lifestyle and goals.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2226">
              During your consultation, our hormone specialists will assess your
              health and medical history to recommend the best treatment option,
              ensuring you regain your energy, confidence, and quality of life.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-2227">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}